// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promptBox{width:800px!important;max-height:300px}.el-table .success-row{background:#51e09b}", ""]);
// Exports
module.exports = exports;
